import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import QRCode from 'qrcode'
import api from '../api'
import { Radio, Play, RotateCw, Square, Zap, CalendarClock, Users, Tag as TagIcon, ScanLine, RefreshCw, Timer, Sparkles, ShieldCheck, Plus, Trash2, BookOpen, PhoneCall, Server } from 'lucide-react'
import { Card, PageHeader, Button, Select, Field, Alert, Avatar, Badge, Input, Textarea, Tabs } from '../components/ui'

export default function BotSettings() {
  // Tab (2026-07-24, rapi-rapi) -- dulu 6 card ditumpuk vertikal, TAPI satu card "AI Chatbot
  // Pelanggan" membengkak jadi wadah 7 topik berbeda (toggle+API key, FAQ, CS Manusia, Admin/CS,
  // 3 macam delay) cuma dipisah garis borderTop -- beda dari 5 card lain di halaman ini yg 1
  // card = 1 topik. Dipecah jadi 3 tab spy tiap tab isinya beberapa card kecil senada, mirror pola
  // yg sama dipakai di AiAsisten.jsx.
  const [tab, setTab] = useState('koneksi')
  const [status, setStatus] = useState(null)
  const [groups, setGroups] = useState([])
  const [loadingGroups, setLoadingGroups] = useState(false)
  const [config, setConfig] = useState({ schedule_enabled: 1, schedule_start_hour: 6, schedule_end_hour: 23, manual_active: 0, sync_hour: 23, sync_minute: 0, wa_delay_min_sec: 3, wa_delay_max_sec: 10, ai_reply_delay_min_sec: 2, ai_reply_delay_max_sec: 6, ai_reply_pelanggan_delay_min_sec: 10, ai_reply_pelanggan_delay_max_sec: 25, cs_manusia_no_hp: '', ai_pause_minutes: 60 })
  const [pesan, setPesan] = useState(null)
  const [qrImg, setQrImg] = useState(null)
  const [apiKeyInput, setApiKeyInput] = useState('')
  const [savingApiKey, setSavingApiKey] = useState(false)
  const [platforms, setPlatforms] = useState([])
  const [botModelInput, setBotModelInput] = useState({ platformId: '', model: '' })
  const botModelInitialized = useRef(false)
  const [savingBotModel, setSavingBotModel] = useState(false)
  const [csNoHpInput, setCsNoHpInput] = useState('')
  const csNoHpInitialized = useRef(false)
  const [savingCsNoHp, setSavingCsNoHp] = useState(false)
  const [infoBisnis, setInfoBisnis] = useState({ namaUsaha: '', paketHarga: '', areaCakupan: '', kontakCs: '' })
  const infoBisnisInitialized = useRef(false)
  const [savingInfoBisnis, setSavingInfoBisnis] = useState(false)
  const [adminList, setAdminList] = useState([])
  const [adminNoHpInput, setAdminNoHpInput] = useState('')
  const [adminNamaInput, setAdminNamaInput] = useState('')
  const [savingAdmin, setSavingAdmin] = useState(false)

  useEffect(() => {
    loadStatus()
    loadAdminList()
    loadPlatforms()
    const interval = setInterval(loadStatus, 5000)
    return () => clearInterval(interval)
  }, [])

  async function loadAdminList() {
    try { const r = await api.get('/admin-wa-kontak'); setAdminList(r.data) } catch {}
  }

  // Platform+model chatbot WA (2026-07-28) -- daftar platform (mis. OpenRouter) diisi/kelola di
  // halaman Platform AI, di sini cuma dropdown pilih platform mana + slug model mana yg dipakai
  // chatbot. Lihat bot/aiCustomerService.js's getBotModelConfig.
  async function loadPlatforms() {
    try { const r = await api.get('/ai-platforms'); setPlatforms(r.data) } catch {}
  }

  async function tambahAdmin() {
    setPesan(null)
    const normalized = normalizePhoneDisplay(adminNoHpInput)
    if (!normalized) { setPesan({ type: 'error', text: 'Format nomor HP admin tidak valid' }); return }
    setSavingAdmin(true)
    try {
      await api.post('/admin-wa-kontak', { no_hp: normalized, nama: adminNamaInput.trim() })
      setAdminNoHpInput('')
      setAdminNamaInput('')
      loadAdminList()
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan nomor admin' }) }
    finally { setSavingAdmin(false) }
  }

  async function hapusAdmin(noHp) {
    if (!window.confirm(`Cabut akses admin dari nomor ${noHp}?`)) return
    await api.delete(`/admin-wa-kontak/${encodeURIComponent(noHp)}`)
    loadAdminList()
  }

  async function loadStatus() {
    try {
      const r = await api.get('/sync/status')
      setStatus(r.data)
      if (r.data.config) setConfig({
        schedule_enabled: r.data.config.schedule_enabled ? 1 : 0,
        schedule_start_hour: r.data.config.schedule_start_hour,
        schedule_end_hour: r.data.config.schedule_end_hour,
        manual_active: r.data.config.manual_active ? 1 : 0,
        sync_hour: r.data.config.sync_hour,
        sync_minute: r.data.config.sync_minute,
        wa_delay_min_sec: r.data.config.wa_delay_min_sec,
        wa_delay_max_sec: r.data.config.wa_delay_max_sec,
        ai_reply_delay_min_sec: r.data.config.ai_reply_delay_min_sec,
        ai_reply_delay_max_sec: r.data.config.ai_reply_delay_max_sec,
        ai_reply_pelanggan_delay_min_sec: r.data.config.ai_reply_pelanggan_delay_min_sec,
        ai_reply_pelanggan_delay_max_sec: r.data.config.ai_reply_pelanggan_delay_max_sec,
        cs_manusia_no_hp: r.data.config.cs_manusia_no_hp || '',
        ai_pause_minutes: r.data.config.ai_pause_minutes
      })
      if (!csNoHpInitialized.current) {
        setCsNoHpInput(r.data.config.cs_manusia_no_hp || '')
        csNoHpInitialized.current = true
      }
      if (!botModelInitialized.current) {
        setBotModelInput({ platformId: r.data.config.bot_platform_id || '', model: r.data.config.bot_model || '' })
        botModelInitialized.current = true
      }
      if (!infoBisnisInitialized.current) {
        setInfoBisnis({
          namaUsaha: r.data.config.business_name || '',
          paketHarga: r.data.config.info_paket_harga || '',
          areaCakupan: r.data.config.info_area_cakupan || '',
          kontakCs: r.data.config.info_kontak_cs || ''
        })
        infoBisnisInitialized.current = true
      }
      if (r.data.qr && r.data.status === 'need_scan') {
        try {
          const url = await QRCode.toDataURL(r.data.qr, { width: 256, margin: 2 })
          setQrImg(url)
        } catch (e) { console.error(e) }
      } else {
        setQrImg(null)
      }
    } catch {}
  }

  async function handleConnect() {
    setPesan(null)
    try {
      await api.post('/sync/connect')
      setPesan({ type: 'success', text: 'Mencoba konek ke WhatsApp...' })
    } catch { setPesan({ type: 'error', text: 'Gagal konek' }) }
  }

  async function handleDisconnect() {
    setPesan(null)
    try {
      await api.post('/sync/disconnect')
      setPesan({ type: 'success', text: 'Bot diputus (session tersimpan)' })
    } catch { setPesan({ type: 'error', text: 'Gagal' }) }
  }

  async function loadGroups() {
    setLoadingGroups(true)
    setPesan(null)
    try {
      const r = await api.get('/sync/groups')
      setGroups(r.data)
    } catch (e) {
      setPesan({ type: 'error', text: e.response?.data?.error || 'Bot harus aktif dulu' })
    } finally { setLoadingGroups(false) }
  }

  async function saveConfig(updates) {
    try {
      await api.post('/sync/config', updates)
      setTimeout(loadStatus, 500)
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan' }) }
  }

  async function saveApiKey() {
    if (!apiKeyInput.trim()) return
    setSavingApiKey(true)
    setPesan(null)
    try {
      await api.post('/sync/config', { anthropic_api_key: apiKeyInput.trim() })
      setApiKeyInput('')
      setPesan({ type: 'success', text: 'API Key tersimpan — langsung dipakai Evaluasi Kinerja AI, tidak perlu restart' })
      setTimeout(loadStatus, 500)
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan API Key' }) }
    finally { setSavingApiKey(false) }
  }

  async function saveBotModel() {
    if (!botModelInput.platformId) { setPesan({ type: 'error', text: 'Pilih platform dulu -- tambahkan di halaman Platform AI kalau belum ada' }); return }
    if (!botModelInput.model.trim()) { setPesan({ type: 'error', text: 'Slug model wajib diisi' }); return }
    setSavingBotModel(true)
    setPesan(null)
    try {
      await api.post('/sync/config', { bot_platform_id: botModelInput.platformId, bot_model: botModelInput.model.trim() })
      setPesan({ type: 'success', text: 'Platform & model chatbot tersimpan — langsung aktif, tidak perlu restart' })
      setTimeout(loadStatus, 500)
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan platform & model chatbot' }) }
    finally { setSavingBotModel(false) }
  }

  // Terima 08xx / +62xx / 62xx, simpan seragam 62xxxxxxxxxx — sama persis dgn normalisasi di
  // server/routes/pelangganKontak.js & bot/aiCustomerService.js, supaya semua tempat yg simpan
  // nomor HP di app ini konsisten formatnya.
  function normalizePhoneDisplay(raw) {
    let digits = String(raw || '').replace(/\D/g, '')
    if (!digits) return null
    if (digits.startsWith('0')) digits = '62' + digits.slice(1)
    else if (digits.startsWith('8')) digits = '62' + digits
    if (!digits.startsWith('62') || digits.length < 10 || digits.length > 15) return null
    return digits
  }

  async function saveCsNoHp() {
    setPesan(null)
    const normalized = csNoHpInput.trim() ? normalizePhoneDisplay(csNoHpInput) : ''
    if (csNoHpInput.trim() && !normalized) { setPesan({ type: 'error', text: 'Format nomor HP CS Manusia tidak valid' }); return }
    setSavingCsNoHp(true)
    try {
      await api.post('/sync/config', { cs_manusia_no_hp: normalized })
      setCsNoHpInput(normalized)
      setPesan({ type: 'success', text: normalized ? 'Nomor CS Manusia tersimpan' : 'Nomor CS Manusia dikosongkan, eskalasi kembali ke grup teknisi' })
      setTimeout(loadStatus, 500)
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan nomor CS Manusia' }) }
    finally { setSavingCsNoHp(false) }
  }

  // Fase 6 rencana perbaikan (2026-07-18) — sebelumnya FAQ paket/harga/area cakupan/kontak CS di
  // chatbot AI hardcode placeholder "[ISI SENDIRI]" di kode, cuma bisa diubah lewat edit file +
  // rebuild + restart. Sekarang tersimpan di bot_config (sama pola dgn API key/nomor CS di atas),
  // langsung berlaku ke percakapan berikutnya tanpa restart apa pun.
  async function saveInfoBisnis() {
    setPesan(null)
    setSavingInfoBisnis(true)
    try {
      await api.post('/sync/config', {
        business_name: infoBisnis.namaUsaha.trim() || 'FazNet',
        info_paket_harga: infoBisnis.paketHarga.trim(),
        info_area_cakupan: infoBisnis.areaCakupan.trim(),
        info_kontak_cs: infoBisnis.kontakCs.trim()
      })
      setPesan({ type: 'success', text: 'Info bisnis tersimpan — langsung dipakai chatbot AI di percakapan berikutnya' })
      setTimeout(loadStatus, 500)
    } catch { setPesan({ type: 'error', text: 'Gagal menyimpan info bisnis' }) }
    finally { setSavingInfoBisnis(false) }
  }

  const waStatus = status?.status || 'disconnected'
  const botConnected = status?.connected
  const targetGroup = status?.targetGroup
  const needScan = waStatus === 'need_scan'

  const statusTone = { connected: 'success', disconnected: 'neutral', connecting: 'warning', need_scan: 'danger' }
  const statusLabel = { connected: 'Terhubung', disconnected: 'Terputus', connecting: 'Menghubungkan...', need_scan: 'Perlu Scan QR' }

  return (
    <div>
      <PageHeader title="Pengaturan Bot" subtitle="Kontrol jadwal & koneksi WhatsApp" />

      {pesan && <Alert type={pesan.type}>{pesan.text}</Alert>}

      <Tabs
        tabs={[['koneksi', 'Koneksi & Jadwal', Radio], ['ai', 'AI Chatbot Pelanggan', Sparkles], ['admin', 'Admin & Eskalasi', ShieldCheck]]}
        active={tab} onChange={setTab}
      />

      {tab === 'koneksi' && <>
      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={Radio}>Status &amp; Koneksi WhatsApp</SectionTitle>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 20 }}>
          <StatusTile label="WhatsApp" value={statusLabel[waStatus] || waStatus} tone={statusTone[waStatus] || 'neutral'} />
          <StatusTile label="Jadwal" value={status?.shouldBeActive ? 'Dalam jadwal' : 'Di luar jadwal'} tone={status?.shouldBeActive ? 'brand' : 'neutral'} />
          <StatusTile label="Grup Target" value={targetGroup?.name || 'Belum dipilih'} tone={targetGroup?.id ? 'success' : 'warning'} />
        </div>

        {needScan && (
          <div style={{ background: 'var(--warning-soft)', border: '1px solid #fcd9a6', borderRadius: 'var(--radius)', padding: 20, marginBottom: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--warning)', marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
              <ScanLine size={16} /> Scan QR Code dengan WhatsApp nomor bot
            </div>
            {qrImg ? (
              <img src={qrImg} alt="QR" style={{ width: 240, height: 240, border: '4px solid #fff', borderRadius: 10, boxShadow: 'var(--shadow)' }} />
            ) : (
              <div style={{ padding: 20, color: 'var(--text-muted)' }}>Memuat QR Code...</div>
            )}
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 10 }}>Buka WhatsApp → Linked Devices → Link a Device → Scan</div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {!botConnected && !needScan && <Button variant="success" icon={Play} onClick={handleConnect}>Hubungkan ke WhatsApp</Button>}
          {needScan && <Button variant="danger" icon={RotateCw} onClick={handleConnect}>Generate QR Baru</Button>}
          {botConnected && <Button variant="danger" icon={Square} onClick={handleDisconnect}>Putus Koneksi (Session Tersimpan)</Button>}
          <Button variant={status?.config?.manual_active ? 'danger' : 'primary'} icon={Zap}
            onClick={() => saveConfig({ manual_active: status?.config?.manual_active ? '0' : '1' })}>
            {status?.config?.manual_active ? 'Kembali ke Jadwal' : 'Paksa Aktif Sekarang'}
          </Button>
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 10 }}>"Putus Koneksi" hanya memutus koneksi sementara — session/akun WA tidak hilang, bot bisa konek lagi tanpa scan QR ulang.</p>
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <SectionTitle icon={CalendarClock}>Jadwal Bot Aktif (WIB)</SectionTitle>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
            <input type="checkbox" checked={!!status?.config?.schedule_enabled} onChange={() => saveConfig({ schedule_enabled: status?.config?.schedule_enabled ? '0' : '1' })} />
            Aktifkan jadwal
          </label>
        </div>
        <div className="grid-2" style={{ gap: 14 }}>
          {[['schedule_start_hour', 'Jam Mulai'], ['schedule_end_hour', 'Jam Selesai']].map(([key, label]) => (
            <Field key={key} label={`${label} (WIB)`}>
              <Select value={config[key]} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, [key]: v }); saveConfig({ [key]: v }) }}>
                {[...Array(24)].map((_, h) => <option key={h} value={h}>{String(h).padStart(2, '0')}:00</option>)}
              </Select>
            </Field>
          ))}
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 12 }}>Bot aktif setiap hari dari <strong>{String(config.schedule_start_hour).padStart(2, '0')}:00</strong> sampai <strong>{String(config.schedule_end_hour).padStart(2, '0')}:00</strong> WIB. Keepalive otomatis setiap 5 menit.</p>
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <SectionTitle icon={Users}>Grup WhatsApp Dipantau</SectionTitle>
          <Button size="sm" icon={RefreshCw} loading={loadingGroups} disabled={!botConnected} onClick={loadGroups}>Ambil Daftar Grup</Button>
        </div>
        {targetGroup?.id && (
          <div style={{ marginBottom: 14, padding: 12, background: 'var(--success-soft)', border: '1px solid #b3e6c8', borderRadius: 'var(--radius-sm)', fontSize: 13 }}>
            <strong style={{ color: 'var(--success)' }}>Aktif memantau:</strong> {targetGroup.name}
          </div>
        )}
        {groups.length > 0 && (
          <div style={{ display: 'grid', gap: 8, maxHeight: 300, overflowY: 'auto' }}>
            {groups.map(g => (
              <div key={g.id} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: 12,
                border: `1px solid ${targetGroup?.id === g.id ? '#b3e6c8' : 'var(--border)'}`,
                borderRadius: 'var(--radius-sm)', background: targetGroup?.id === g.id ? 'var(--success-soft)' : 'transparent'
              }}>
                <Avatar label={g.subject.charAt(0).toUpperCase()} size={38} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600 }}>{g.subject}</div>
                  <div style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>{g.size} anggota</div>
                </div>
                <Button size="sm" variant={targetGroup?.id === g.id ? 'success' : 'primary'}
                  onClick={() => saveConfig({ target_group_id: g.id, target_group_name: g.subject })}>
                  {targetGroup?.id === g.id ? 'Dipilih' : 'Pilih'}
                </Button>
              </div>
            ))}
          </div>
        )}
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={Timer}>Delay Kirim WA (Alert Grup)</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>Jeda acak sebelum tiap pesan WA ke grup teknisi terkirim (mis. banyak tiket redaman jadi Terbuka sekaligus) — supaya tidak terlihat seperti spam dan berisiko nomor bot diblokir WhatsApp. Khusus balasan chatbot AI ke pelanggan pribadi pakai jeda terpisah, lihat tab "AI Chatbot Pelanggan".</p>
        <div className="grid-2" style={{ gap: 14 }}>
          <Field label="Delay Minimal (detik)">
            <Select value={config.wa_delay_min_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, wa_delay_min_sec: v }); saveConfig({ wa_delay_min_sec: v }) }}>
              {[0, 1, 2, 3, 5, 8, 10, 15, 20, 30].map(s => <option key={s} value={s}>{s} detik</option>)}
            </Select>
          </Field>
          <Field label="Delay Maksimal (detik)">
            <Select value={config.wa_delay_max_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, wa_delay_max_sec: v }); saveConfig({ wa_delay_max_sec: v }) }}>
              {[3, 5, 8, 10, 15, 20, 30, 45, 60, 90, 120].map(s => <option key={s} value={s}>{s} detik</option>)}
            </Select>
          </Field>
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 12 }}>Tiap pesan menunggu jeda acak antara <strong>{config.wa_delay_min_sec} detik</strong> dan <strong>{config.wa_delay_max_sec} detik</strong> sebelum terkirim. Berlaku utk semua pengiriman WA di aplikasi ini (tiket redaman, konfirmasi selesai, dll), diproses satu-satu berurutan.</p>
      </Card>

      <Card style={{ padding: 24 }}>
        <SectionTitle icon={TagIcon}>Sync Re-process Harian</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>Memproses ulang log yang belum masuk ke rekap</p>
        <div className="grid-2" style={{ gap: 14 }}>
          <Field label="Jam Sync">
            <Select value={config.sync_hour} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, sync_hour: v }); saveConfig({ sync_hour: v }) }}>
              {[...Array(24)].map((_, h) => <option key={h} value={h}>{String(h).padStart(2, '0')}</option>)}
            </Select>
          </Field>
          <Field label="Menit Sync">
            <Select value={config.sync_minute} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, sync_minute: v }); saveConfig({ sync_minute: v }) }}>
              {[0, 15, 30, 45].map(m => <option key={m} value={m}>{String(m).padStart(2, '0')}</option>)}
            </Select>
          </Field>
        </div>
      </Card>
      </>}

      {tab === 'ai' && <>
      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={Sparkles}>AI Chatbot Pelanggan</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Pilih platform & model AI (dikelola di <Link to="/ai-platforms">Platform AI</Link>) supaya chatbot bisa membalas chat pribadi pelanggan — cek status koneksi, lapor gangguan, catat minat PSB, ganti password WiFi. Tanpa ini diisi, pesan pribadi pelanggan tidak dibalas otomatis.
        </p>
        <div style={{ marginBottom: 14, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <Badge tone={status?.config?.bot_platform_id && status?.config?.bot_model ? 'success' : 'warning'}>
            {status?.config?.bot_platform_id && status?.config?.bot_model ? 'Platform & model sudah diatur' : 'Platform & model belum diatur'}
          </Badge>
          <Badge tone={status?.config?.ai_chatbot_pelanggan_enabled ? 'success' : 'neutral'}>
            {status?.config?.ai_chatbot_pelanggan_enabled ? 'Chatbot Aktif' : 'Chatbot Dimatikan'}
          </Badge>
        </div>
        <Button
          variant={status?.config?.ai_chatbot_pelanggan_enabled ? 'danger' : 'success'}
          icon={status?.config?.ai_chatbot_pelanggan_enabled ? Square : Play}
          onClick={() => saveConfig({ ai_chatbot_pelanggan_enabled: status?.config?.ai_chatbot_pelanggan_enabled ? '0' : '1' })}
          style={{ marginBottom: 6 }}
        >
          {status?.config?.ai_chatbot_pelanggan_enabled ? 'Matikan Chatbot AI' : 'Hidupkan Chatbot AI'}
        </Button>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 0, marginBottom: 20 }}>
          {status?.config?.ai_chatbot_pelanggan_enabled
            ? 'AI sedang membalas chat pribadi pelanggan otomatis. Matikan kalau mau tangani manual sementara (mis. lagi ada gangguan massal) tanpa harus hapus pengaturan platform.'
            : 'AI TIDAK membalas chat pribadi pelanggan sama sekali sekarang, walau platform sudah diatur — pesan pelanggan tidak tercatat di Log Chat AI selama dimatikan. Hidupkan lagi kapan saja.'}
        </p>

        {platforms.length === 0 && (
          <Alert type="error">
            Belum ada platform AI. Tambahkan dulu di halaman <Link to="/ai-platforms">Platform AI</Link> (mis. OpenRouter) sebelum bisa mengatur chatbot ini.
          </Alert>
        )}

        {platforms.length > 0 && <>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Field label="Platform" style={{ flex: '0 0 200px' }}>
              <Select value={botModelInput.platformId} onChange={e => setBotModelInput({ ...botModelInput, platformId: e.target.value })}>
                <option value="">-- pilih platform --</option>
                {platforms.map(p => <option key={p.id} value={p.id} disabled={!p.aktif}>{p.nama}{!p.aktif ? ' (nonaktif)' : ''}</option>)}
              </Select>
            </Field>
            <Field label="Model" style={{ flex: 1, minWidth: 220 }}>
              <Input value={botModelInput.model} onChange={e => setBotModelInput({ ...botModelInput, model: e.target.value })} placeholder="mis. anthropic/claude-haiku-4.5" style={{ fontFamily: 'monospace', fontSize: 12.5 }} />
            </Field>
          </div>
          <Button loading={savingBotModel} onClick={saveBotModel}>Simpan Platform & Model</Button>
          <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 12 }}>Slug model ikut format platform yg dipilih (utk OpenRouter, salin dari <span style={{ fontFamily: 'monospace' }}>openrouter.ai/models</span>).</p>
        </>}
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={BookOpen}>Info Bisnis (FAQ Chatbot)</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Dipakai chatbot AI menjawab pertanyaan umum pelanggan (paket/harga, area cakupan, kontak CS) — sebelum diisi, AI akan bilang belum tahu & mengarahkan ke admin. Perubahan di sini langsung berlaku ke percakapan berikutnya, tidak perlu restart.
        </p>
        <Field label="Nama Usaha" style={{ marginBottom: 4 }}>
          <Input value={infoBisnis.namaUsaha} onChange={e => setInfoBisnis({ ...infoBisnis, namaUsaha: e.target.value })}
            placeholder="Contoh: FazNet" />
        </Field>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginBottom: 12 }}>Dipakai chatbot AI menyebut diri sendiri, Evaluasi AI (HRD), dan tampil di halaman login/sidebar/slip gaji/form publik.</p>
        <Field label="Paket & Harga" style={{ marginBottom: 12 }}>
          <Textarea rows={3} value={infoBisnis.paketHarga} onChange={e => setInfoBisnis({ ...infoBisnis, paketHarga: e.target.value })}
            placeholder={'Contoh:\n10 Mbps - Rp150.000/bulan\n20 Mbps - Rp200.000/bulan\n50 Mbps - Rp350.000/bulan'} />
        </Field>
        <Field label="Area Cakupan" style={{ marginBottom: 12 }}>
          <Textarea rows={2} value={infoBisnis.areaCakupan} onChange={e => setInfoBisnis({ ...infoBisnis, areaCakupan: e.target.value })}
            placeholder="Contoh: Kudus, Jati, Mejobo, dan sekitarnya" />
        </Field>
        <Field label="Kontak CS (teks jawaban ke pelanggan, BUKAN nomor eskalasi di tab Admin & Eskalasi)" style={{ marginBottom: 14 }}>
          <Input value={infoBisnis.kontakCs} onChange={e => setInfoBisnis({ ...infoBisnis, kontakCs: e.target.value })}
            placeholder="Contoh: 0812xxxxxxxx (jam kerja 08.00-17.00)" />
        </Field>
        <Button loading={savingInfoBisnis} onClick={saveInfoBisnis}>Simpan Info Bisnis</Button>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 10 }}>Beda dari "CS Manusia" di tab Admin & Eskalasi — field itu tujuan pesan eskalasi AI (internal), field ini isi jawaban AI kalau pelanggan tanya kontak CS (bisa nomor/jam kerja yang berbeda).</p>
      </Card>

      <Card style={{ padding: 24 }}>
        <SectionTitle icon={Timer}>Tahan Balasan Chatbot — Pelanggan</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Balasan AI ke pelanggan biasa (bukan Admin/CS) <strong>DITAHAN dulu</strong> selama rentang ini, BUKAN cuma jeda kirim singkat spt Admin/CS. Kalau admin sempat balas manual duluan sebelum waktu ini habis, balasan AI itu <strong>otomatis dibatalkan</strong> (tidak jadi terkirim) — kalau tidak ada respon admin sama sekali, baru balasan AI dikirim setelah waktunya habis. Cocok kalau AI belum dipercaya sepenuhnya melayani pelanggan sendirian.
        </p>
        <div className="grid-2" style={{ gap: 14 }}>
          <Field label="Tahan Minimal">
            <Select value={config.ai_reply_pelanggan_delay_min_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, ai_reply_pelanggan_delay_min_sec: v }); saveConfig({ ai_reply_pelanggan_delay_min_sec: v }) }}>
              {[0, 60, 300, 600, 900, 1800, 2700, 3600, 5400, 7200].map(s => <option key={s} value={s}>{formatDurasiSingkat(s)}</option>)}
            </Select>
          </Field>
          <Field label="Tahan Maksimal">
            <Select value={config.ai_reply_pelanggan_delay_max_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, ai_reply_pelanggan_delay_max_sec: v }); saveConfig({ ai_reply_pelanggan_delay_max_sec: v }) }}>
              {[300, 600, 900, 1800, 2700, 3600, 5400, 7200, 10800, 14400].map(s => <option key={s} value={s}>{formatDurasiSingkat(s)}</option>)}
            </Select>
          </Field>
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 12 }}>Tiap balasan AI ke pelanggan ditahan acak antara <strong>{formatDurasiSingkat(config.ai_reply_pelanggan_delay_min_sec)}</strong> dan <strong>{formatDurasiSingkat(config.ai_reply_pelanggan_delay_max_sec)}</strong> — dicek tiap menit, dikirim/dibatalkan begitu waktunya habis.</p>
      </Card>

      <Card style={{ padding: 24 }}>
        <SectionTitle icon={Zap}>Evaluasi Kinerja AI (Payroll)</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Fitur TERPISAH dari chatbot pelanggan di atas — dipakai AI menyarankan catatan evaluasi & potongan gaji teknisi (form Buat Slip di halaman Payroll). Masih langsung pakai API Key Anthropic (Claude), belum ikut sistem Platform AI.
        </p>
        <Badge tone={status?.hasAnthropicKey ? 'success' : 'warning'} style={{ marginBottom: 14 }}>
          {status?.hasAnthropicKey ? 'API Key sudah diatur' : 'API Key belum diatur'}
        </Badge>
        <Field label="Anthropic API Key" style={{ marginBottom: 14 }}>
          <Input type="password" value={apiKeyInput} onChange={e => setApiKeyInput(e.target.value)} placeholder="sk-ant-..." autoComplete="off" />
        </Field>
        <Button loading={savingApiKey} disabled={!apiKeyInput.trim()} onClick={saveApiKey}>Simpan API Key</Button>
        <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 12 }}>Key tersimpan di database bot, tidak pernah ditampilkan lagi setelah disimpan. Bisa diganti kapan saja dengan mengisi ulang form ini.</p>
      </Card>
      </>}

      {tab === 'admin' && <>
      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={PhoneCall}>CS Manusia</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>Kalau AI mentok dan perlu eskalasi ke manusia, kirim langsung ke nomor WA CS ini (bukan ke grup WA teknisi). Kosongkan untuk kembali kirim ke grup teknisi.</p>
        <Field label="Nomor WA CS Manusia" style={{ marginBottom: 10 }}>
          <Input value={csNoHpInput} onChange={e => setCsNoHpInput(e.target.value)} placeholder="08xx / 62xx / +62xx" />
        </Field>
        <Button loading={savingCsNoHp} onClick={saveCsNoHp}>Simpan Nomor CS</Button>
        {config.cs_manusia_no_hp && (
          <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginTop: 10 }}>Aktif — eskalasi AI sekarang dikirim ke <strong>{config.cs_manusia_no_hp}</strong>.</p>
        )}
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={ShieldCheck}>Nomor Admin/CS (Mode Privileged AI)</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Nomor WA di daftar ini dikenali AI sebagai admin/CS, bukan pelanggan biasa — begitu chat dari nomor ini, AI membuka tools tambahan: cek status pelanggan lain, lihat & ganti password WiFi pelanggan lain, dan reboot modem pelanggan lain (username PPPoE disebut langsung di chat). Ganti password & reboot tetap minta konfirmasi ulang dari AI sebelum dieksekusi.
        </p>
        <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
          <Input value={adminNoHpInput} onChange={e => setAdminNoHpInput(e.target.value)} placeholder="08xx / 62xx / +62xx" style={{ flex: '1 1 180px' }} />
          <Input value={adminNamaInput} onChange={e => setAdminNamaInput(e.target.value)} placeholder="Nama (opsional)" style={{ flex: '1 1 140px' }} />
          <Button icon={Plus} loading={savingAdmin} disabled={!adminNoHpInput.trim()} onClick={tambahAdmin}>Tambah</Button>
        </div>
        {adminList.length === 0 ? (
          <p style={{ fontSize: 12, color: 'var(--text-faint)' }}>Belum ada nomor admin/CS terdaftar — semua chat pribadi diperlakukan sebagai pelanggan biasa.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {adminList.map(a => (
              <div key={a.no_hp} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: '#fafafc', border: '1px solid var(--border)', borderRadius: 8 }}>
                <div style={{ fontSize: 12.5 }}><strong>{a.no_hp}</strong>{a.nama ? ` · ${a.nama}` : ''}</div>
                <button onClick={() => hapusAdmin(a.no_hp)} title="Cabut akses" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--danger)' }}>
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </Card>

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={Timer}>Jeda Otomatis Saat Admin Balas Manual</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>Admin di sini melayani pelanggan dari nomor admin/bot yang sama, bukan HP pribadi terpisah. Begitu admin balas manual lewat WA app, AI otomatis "diam" untuk nomor pelanggan itu supaya tidak dobel/kontradiksi balasan — bisa diaktifkan lagi kapan saja dari halaman Log Chat AI.</p>
        <Field label="Durasi jeda AI">
          <Select value={config.ai_pause_minutes} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, ai_pause_minutes: v }); saveConfig({ ai_pause_minutes: v }) }}>
            {[15, 30, 60, 120, 240, 480].map(m => <option key={m} value={m}>{m < 60 ? `${m} menit` : `${m / 60} jam`}</option>)}
          </Select>
        </Field>
      </Card>

      <Card style={{ padding: 24 }}>
        <SectionTitle icon={Timer}>Delay Balasan Chatbot — Admin/CS</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>Khusus balasan AI ke nomor yang terdaftar sbg Admin/CS di atas — dibuat singkat (bukan ikut delay alert grup) supaya tetap responsif dipakai sepanjang shift kerja. Tidak berlaku utk pelanggan biasa, lihat tab AI Chatbot Pelanggan.</p>
        <div className="grid-2" style={{ gap: 14 }}>
          <Field label="Delay Minimal (detik)">
            <Select value={config.ai_reply_delay_min_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, ai_reply_delay_min_sec: v }); saveConfig({ ai_reply_delay_min_sec: v }) }}>
              {[0, 1, 2, 3, 5, 8, 10].map(s => <option key={s} value={s}>{s} detik</option>)}
            </Select>
          </Field>
          <Field label="Delay Maksimal (detik)">
            <Select value={config.ai_reply_delay_max_sec} onChange={e => { const v = parseInt(e.target.value); setConfig({ ...config, ai_reply_delay_max_sec: v }); saveConfig({ ai_reply_delay_max_sec: v }) }}>
              {[2, 3, 5, 8, 10, 15, 20, 30].map(s => <option key={s} value={s}>{s} detik</option>)}
            </Select>
          </Field>
        </div>
      </Card>
      </>}
    </div>
  )
}

// Label ramah utk pilihan durasi tahan (detik) di dropdown Tahan Balasan Chatbot Pelanggan --
// rentangnya sampai berjam-jam (2026-07-22), jadi label "N detik" saja sudah tidak cukup jelas.
function formatDurasiSingkat(detik) {
  if (detik < 60) return `${detik} detik`
  if (detik < 3600) return `${Math.round(detik / 60)} menit`
  const jam = detik / 3600
  return `${Number.isInteger(jam) ? jam : jam.toFixed(1)} jam`
}

function SectionTitle({ icon: Icon, children }) {
  return (
    <h2 style={{ fontSize: 14.5, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text)' }}>
      <Icon size={16} color="var(--brand)" />{children}
    </h2>
  )
}

const toneMap = {
  success: { bg: 'var(--success-soft)', border: '#b3e6c8', color: 'var(--success)' },
  warning: { bg: 'var(--warning-soft)', border: '#fcd9a6', color: 'var(--warning)' },
  brand: { bg: 'var(--brand-soft)', border: '#c7cdfb', color: 'var(--brand-soft-text)' },
  neutral: { bg: '#f4f4f6', border: 'var(--border)', color: 'var(--text-muted)' },
}

function StatusTile({ label, value, tone }) {
  const t = toneMap[tone] || toneMap.neutral
  return (
    <div style={{ padding: 14, borderRadius: 'var(--radius-sm)', background: t.bg, border: `1px solid ${t.border}` }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>{label}</div>
      <div style={{ fontSize: 15.5, fontWeight: 700, color: t.color, marginTop: 4 }}>{value}</div>
    </div>
  )
}
